import { UseFilePickerConfig, Validator } from 'use-file-picker';
import { MimeTypes } from '../fileMimeTypes';
import { FileWithPath } from 'file-selector';

export const UnsupportedFileType = 'unsupportedFileType';

export class FileTypeValidator implements Validator {
  validateBeforeParsing(config: UseFilePickerConfig, plainFiles: File[]) {
    const acceptedTypes = []
      .concat(config.accept)
      .map((v) => MimeTypes[v].valueOf());

    return new Promise<void>((res, rej) =>
      Array.from(plainFiles).every((file) => acceptedTypes.includes(file.type))
        ? res()
        : rej({ name: UnsupportedFileType }),
    );
  }

  validateAfterParsing(
    _config: UseFilePickerConfig,
    _file: FileWithPath,
    _reader: FileReader,
  ) {
    return Promise.resolve();
  }
}
